module.exports = __webpack_public_path__ + "img/soonGet.2ab64381.png";